import React, { FC, memo } from "../../../lib/teact/teact";
import Spinner from "../../ui/Spinner";

import './lotSpinner.scss'
type OwerProp = {
    size?: string;
    className?: string;
}

const LotSpinner: FC<OwerProp> = ({
    size,
    className,
}) => {
    let clsName = "";
    switch (size) {
        case "small":
            clsName = "lot-spinner-small";
            break;
        case "small-x":
            clsName = "lot-spinner-small-x";
            break;
        default:
            ""
    }
    if (className)
        clsName += " " + className
    return (
        <Spinner className={clsName} ></Spinner>
    )
}
export default memo(LotSpinner)